import { FunctionComponent, useState } from 'react';
import { Typography, IconButton, Chip, Dialog, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { FlightSchedule, LineWorkPackages } from '../../types/line';
import { FlightTakeoff, Link } from '../icons';
import { redirectToMxi } from './../../config/mxiProvider';
import { DateTime } from 'luxon';

type FlightScheduleScheduleProps = {
    flights: FlightSchedule[],
    isMonitor: boolean
}

const FlightScheduleComponent: FunctionComponent<FlightScheduleScheduleProps> = ({ flights, isMonitor }) => {
    const [paperWorkDialogOpen, setPapaerWorkDialogOpen] = useState(false);
    const [paperWorkPackages, setPaperWorkPackages] = useState(Array<LineWorkPackages>());
    const [tailNumber, setTailNumber] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const generateTablePaperworkBody = (row: LineWorkPackages, index: number) => {
        return (
            <TableRow>
                <TableCell>{index}</TableCell>
                <TableCell onClick={() => redirectToMxi(row.wo_barcode)}><IconButton><Link color="primary" /></IconButton></TableCell>
                <TableCell>{row.wo_status}</TableCell>
                <TableCell>{row.wo_name}</TableCell>
                <TableCell>{row.wo_number}</TableCell>
                <TableCell>{row.start_date_text}</TableCell>
            </TableRow>
        )
    }
    const tableCellFontSize = (isMonitor: boolean) => {
        if (isMonitor === true) {
            return 'h2';
        } else {
            return 'h5';
        }
    }
    const mechanicChipClass = isMonitor ? 'h-auto py-1 px-3 text-xl' : '';

    const generateTableBody = (row: FlightSchedule, index: number) => {
        const dotted = row.wo_status_for_aircraft.status === "Incomplete paperwork";
        return (
            <TableRow
                // AOG uses red-300 (the Tool Stock overdue red) on purpose - a product decision, not drift.
                className={(row.wo_status_for_aircraft.status === "In Air" || row.wo_status_for_aircraft.status === "Incomplete paperwork") ? "bg-[lightyellow]" :
                    row.wo_status_for_aircraft.status === "In Work" ? "bg-[lightblue]" :
                        row.wo_status_for_aircraft.status === "Closed" ? "bg-[#63AB62]" :
                            row.wo_status_for_aircraft.status === "AOG" ? "bg-red-300" : ""
                }
            >
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""} onClick={() => onTailNumberClicked(row)}><Typography text={row.tailNumber} variant={tableCellFontSize(isMonitor)} /></TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""}>{row.currentAirport === "IN-AIR" ? <FlightTakeoff className="h-[30px]" /> : <Typography text={row.currentAirport} variant={tableCellFontSize(isMonitor)} />}</TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""}><Typography text={row.currentStand} variant={tableCellFontSize(isMonitor)} /></TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""}><Typography text={`${row.arrivalFlightNumberAndDepartureAirport}`} variant={tableCellFontSize(isMonitor)} /></TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""}><Typography text={row.arrivalTime ? DateTime.fromJSDate(new Date(row.arrivalTime)).toFormat('dd.MM.yyyy HH:mm') : ''} variant={tableCellFontSize(isMonitor)} /></TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""}><Typography text={row.departureTime ? DateTime.fromJSDate(new Date(row.departureTime)).toFormat('dd.MM.yyyy HH:mm') : ''} variant={tableCellFontSize(isMonitor)} /></TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""}><Typography text={`${row.departureFlightNumberAndDepartureAirport}`} variant={tableCellFontSize(isMonitor)} /></TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-dashed border-gray-500" : ""} >
                    <div className="flex flex-wrap items-center gap-1">
                        {row.assigned_mechanics.map((item, idx) => (
                            <Chip key={idx} size="small" color="primary" className={mechanicChipClass} label={item.abbreviation ? item.abbreviation : "?"} />
                        ))}
                    </div>
                </TableCell>
                <TableCell className={dotted ? "border-t-2 border-b-2 border-r-2 border-dashed border-gray-500" : ""}><Typography text={row.remarks} variant={tableCellFontSize(isMonitor)} /></TableCell>
            </TableRow>
        )
    }
    const onTailNumberClicked = (row: FlightSchedule) => {
        if (row.wo_status_for_aircraft.lineWorkpackages?.length > 0) {
            setPapaerWorkDialogOpen(true);
            setTailNumber(row.tailNumber);
            setErrorMessage("");
            setPaperWorkPackages(row.wo_status_for_aircraft.lineWorkpackages);

        } else {
            setPapaerWorkDialogOpen(true);
            setTailNumber(row.tailNumber);
            setErrorMessage("No packages are scheduled on aircraft");
            setPaperWorkPackages(Array<LineWorkPackages>());
        }
    }
    return (
        <div>
            <Table
                headers={["Tail", "Curr Airport", "Stand", "Arr Fl, nr.", "Arrival", "Departure", "Dep Fl. nr.", "Mechanics", "Remarks"]}
                rows={flights}
                generateBody={(row: any, index: number) => generateTableBody(row, index)}
                pagination={false}
                skipIndexCol={true}
            />
            <Dialog
                visible={paperWorkDialogOpen}
                max_width={"md"}
                title={`Paperwork for : ${tailNumber}`}
                context={
                    <div>
                        {
                            errorMessage !== "" ? <Typography text={errorMessage} variant='h2' align='center' />
                                :
                                <Table
                                    headers={["Mxi", "Status", "Wo name", "Wo number", "start"]}
                                    rows={paperWorkPackages}
                                    generateBody={(row: any, index: number) => generateTablePaperworkBody(row, index)}
                                    pagination={false}
                                    skipIndexCol={false}
                                />
                        }
                    </div>
                }
                onClose={(status: any) => { setPapaerWorkDialogOpen(false); setPaperWorkPackages([]) }}
                strict={false}
                show_options={false}
            />
        </div>
    );
};
export default FlightScheduleComponent;